package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.IdUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent

@Composable
fun AppleWallet(
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
    info: GetVirtualCardConfig?
){
    Column(
        modifier = Modifier
            .margin(leftRight = Dimen.normalPadding)
    ) {
        MediumContentTitle(
            title = Strings.current().appleWallet,
            marginTop = Dimen.mediumPadding,
            marginBottom = Dimen.mediumPadding,
        )

        WalletImgContent(
            title = Strings.current().wideCompanyLogo,
            img = info?.wideLogoImg,
            width = Dimen.selectRectPhoneWidth,
            height =Dimen.selectRectPhoneHeight,
            imgId = IdUtils.wideLogoImg,
            updateImg = {
                event(OptionsEvent.UpdateVirtualCardInfo(
                    dataTitle = ApiUtils.Field.wideLogoImg,
                    dataValue = it
                ))
            }
        )

        BoxColor(
            modifier = Modifier.margin(
                topBottom = Dimen.normalPadding,
            ),
            color = info?.foregroundColor,
            title = Strings.current().fontColor,
            onColorBoxClick = {
                event(OptionsEvent.OnColorBoxClick(
                    selectedColorField = ApiUtils.Field.foregroundColor
                ))
            }
        )

        BoxColor(
            color = info?.labelColor,
            title = Strings.current().titleFontColor,
            onColorBoxClick = {
                event(OptionsEvent.OnColorBoxClick(
                    selectedColorField = ApiUtils.Field.labelColor
                ))
            }
        )


        CustomButton(
            modifier = Modifier
                .margin(topBottom = Dimen.mediumPadding),
            title = Strings.current().preview,
            buttonType = ButtonTypes.CONTAINED,
            windowSizeMode = windowSizeMode,
            onButtonClick = {
                event(OptionsEvent.OnPreviewAppleWalletClick)
            },
        )

    }


}